import React from 'react';

const Split = () => {
    return (
      <React.Fragment>
        {/* Start Split */}
        <div className="btn__base r4c3">
          <div className="btn">
            <div className="numbox">
              <div className="num">
                <div className="sci">✂</div>
              </div>
              <div className="btm">JOIN</div>
            </div>
          </div>
        </div>
        {/* End Split */}
      </React.Fragment>
    );
  };

export default Split;